import React from "react";

const mondayOf = (dateStr) => {
  const d = new Date(dateStr + "T00:00:00Z");
  const day = (d.getUTCDay() + 6) % 7;
  d.setUTCDate(d.getUTCDate() - day);
  return d.toISOString().slice(0, 10);
};

const fmt = (iso) => {
  const [, m, d] = iso.split("-");
  return `${d}/${m}`;
};

/** Weekly members chart built from the nightly snapshots (last value of each week). */
export const TelegramGrowthChart = ({ snapshots }) => {
  const byWeek = new Map();
  (snapshots || []).forEach((s) => {
    if (s?.date && typeof s.members === "number") byWeek.set(mondayOf(s.date), s.members);
  });
  const weeks = [...byWeek.entries()].sort(([a], [b]) => a.localeCompare(b)).slice(-8);

  if (weeks.length === 0) {
    return (
      <p className="text-[11px] text-gray-400 mt-4 border-t pt-4" data-testid="telegram-growth-chart-empty">
        📈 Il grafico settimanale si popola con i riepiloghi serali (primo dato dopo le 20:30).
      </p>
    );
  }

  const max = Math.max(...weeks.map(([, m]) => m), 1);
  return (
    <div className="mt-4 border-t pt-4" data-testid="telegram-growth-chart">
      <p className="text-xs font-semibold text-gray-600 mb-2">📈 Iscritti per settimana</p>
      <div className="flex items-end gap-2 h-24">
        {weeks.map(([week, members], i) => {
          const prev = i > 0 ? weeks[i - 1][1] : null;
          const delta = prev == null ? null : members - prev;
          return (
            <div key={week} className="flex-1 max-w-[140px] flex flex-col items-center justify-end gap-1 h-full" title={`Settimana del ${fmt(week)}: ${members} iscritti`} data-testid={`telegram-week-${week}`}>
              <span className={`text-[10px] font-bold ${delta == null ? "text-gray-500" : delta >= 0 ? "text-green-600" : "text-red-500"}`}>
                {members}{delta != null && delta !== 0 ? ` (${delta > 0 ? "+" : ""}${delta})` : ""}
              </span>
              <div className="w-full bg-[#229ED9]/80 rounded-t" style={{ height: `${Math.max(6, (members / max) * 100)}%` }} />
              <span className="text-[9px] text-gray-400">{fmt(week)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
